import { useSession } from '@pickleballinc/ui/components/global/SessionProvider';
import { useState } from 'react';

import { FavoriteButton } from '@/modules/league/search-page/FavoriteButton';
import { LeagueCardProps, LeagueListCard } from '@/modules/league/search-page/LeagueListCard';

export const FavoriteLeagueCard = ({ ...leagueProps }: LeagueCardProps) => {
  const [isFavorited, setIsFavorited] = useState(leagueProps.league.isFavorite || false);
  const { session } = useSession();

  return (
    <div className='relative flex w-full hover:opacity-80'>
      {session?.user?.uuid ? (
        <div className='absolute right-2 top-2 z-10'>
          <FavoriteButton
            isFavorited={isFavorited}
            setIsFavorited={setIsFavorited}
            moduleUuid={leagueProps.league.LeagueID}
          />
        </div>
      ) : null}
      <LeagueListCard {...leagueProps} />
    </div>
  );
};
